<template>
  <div class="empty-box" >
    暂无数据
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped >
  .empty-box{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 100%;
    color: #bbbbbb;
  }
</style>